import { defineComponent } from '@vue/composition-api';
export default defineComponent({
    name: 'DpSidebar',
    props: {
        title: { type: String, default: null },
    },
});
